<template>
  <div>
  <div class="clearfix">
    <div class="center bb-mt2pt56
      xl-col xl-col-5 bb-xl-ml2 bb-xl-left-align">
      <div class="bb-ff2 bb-fs1pt2 bb-fc1">
       {{ $lang.messages.address}}
      </div>
      <div class="bb-mt0pt81 bb-ff2 bb-fs1pt29 bb-fc3">
        {{ $lang.messages.address_loc_p1 }}<br/>{{ $lang.messages.address_loc_p2 }}
      </div>
      <div class="mt2 bb-xl-mt1 bb-w100p">
        <div class="xs-hide sm-hide md-hide inline-block overflow-hidden bb-xl-hover-trigger2 bb-xl-pointer bb-max-w50 bb-w80p"
        @click="showMap(true)">
          <img class="bb-w100p bb-transition2" src='../assets/images/BBang-Studios-Map.jpg'/>
        </div>
        <div class="lg-hide xl-hide inline-block overflow-hidden bb-max-w50 bb-w80p">
          <img class="bb-w100p bb-transition2" src='../assets/images/BBang-Studios-Map.jpg'/>
        </div>
      </div>
    </div>
    <div class="center col-10 bb-max-w34 mx-auto bb-mt2pt56
      lg-col-4
      xl-col">
      <div class="bb-ff2 bb-fs1pt2 bb-fc1 bb-xl-left-align">
        {{ $lang.messages.email }}
      </div>
      <div class="bb-mt0pt81 bb-ff2 bb-fs1pt29 bb-fc3 bb-xl-left-align">
        {{ $lang.messages.email_add }}
      </div>
      <div class="bb-ff2 bb-fs1pt2 bb-fc1 bb-xl-left-align mt2 bb-xl-mt1">
        {{ $lang.messages.phone }}
      </div>
      <div class="bb-mt0pt81 bb-ff2 bb-fs1pt29 bb-fc3 bb-xl-left-align">
        {{ $lang.messages.phone_num }}
      </div>
      <div class="bb-ff2 bb-fs1pt2 bb-fc1
        bb-xl-left-align mt2 bb-xl-mt1">
        {{ $lang.messages.subscribe}}
      </div>
      <div class="border-box bb-mxw31pt3 bb-xl-ml0 mt3 mx-auto relative">
        <div class="absolute left-0 bb-top1 bb-transform1 bb-fc1 bb-ff2 bb-zindex0"
          :class="{'bb-transform2': inputMailActive}">
          {{ mailPlaceholder }}
        </div>
        <input type="text"
          class="bb-bc-transp border-box mx-auto
          bb-ff2 bb-fs1 bb-w100p bb-h2pt8 bb-brd-top0
          bb-brd-left0 bb-brd-right0 p0 bb-fc1 relative bb-zindex1"
          :class="[ invalidMail ? 'bb-brd5 bb-fc5' : 'bb-brd-bot1 bb-fc1' ]"
          v-model="mailInput"
          @blur="blurMailPlaceholder"
          @input="resetValidation"
          @focus="inputMailClicked">
      </div>
      <div class="center mx-auto border-box bb-pointer bb-sm-bc-transp
        bb-ff3 bb-fs1 bb-brd3 bb-mxw31pt3 bb-xl-ml0
        bb-h2pt8 bb-py1pt25 bb-lh0 bb-transition2 bb-mt1pt7 relative"
        @click="subscribeBtnClicked"
        :class="[ loadingMail ? 'bb-fc13' : 'bb-bc2 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-bc2-hover' ]">
        {{ $lang.messages.send }}
        <div class="absolute bb-vhcr bb-h90p bb-w100p" v-if="loadingMail">
          <img class="bb-h100p" src="../assets/images/loader.svg"></img>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="xs-hide sm-hide md-hide absolute top-0 left-0 bb-zindex1 bb-bc10 bb-h100vh bb-w100vw
      bb-fullscreen bb-usnone" v-if="largeMap" @click="highlightCloseBtn">
        <div class="mx-auto relative bb-vcr bb-bc11 bb-fs0 bb-w24pt12 bb-xl-w70 bb-lg-w50 bb-md-w40">
          <img class="bb-w100p" src='../assets/images/BBang-Studios-Map.jpg'/>
          <div class="bb-rightn1pt5 bb-topn1pt5 bb-br2 bb-w3 bb-h3 bb-bc7 absolute
          bb-pointer" @click="showMap(false)" :class="[cancelTransitionClass,
          closeBtnHighlighted ? 'bb-scale-1pt2' : '' ]">
            <img class="bb-w1pt5 relative bb-vhcr" src='../assets/icons/close.svg'/>
          </div>
        </div>
      </div>
    </transition>
  </div>
  </div>
</template>

<script>

export default {
  name: 'Contact',
  data () {
    return {
      mailPlaceholder: this.$lang.messages.p6,
      mailInput: '',
      loadingMail: false,
      inputMailActive: false,
      invalidMail: false,
      largeMap: false,
      closeBtnHighlighted: false,
      cancelTransitionClass: 'bb-transition2'
    }
  },
  methods: {
    blurMailPlaceholder: function (event) {
      if (event.target.value.length <= 0) {
        this.inputMailActive = false
      }
    },
    inputMailClicked: function () {
      this.inputMailActive = true 
    },
    resetValidation: function () {
      console.log(123)
      if (this.invalidMail) {
        this.invalidMail = false
      }
    },
    subscribeBtnClicked: function () {
      this.loadingMail = true
      this.$store.dispatch('SUBSCRIBE', {
        format: 'newsletter',
        mail: this.mailInput,
        sub: true
      })
    },
    subscribeUpdated: function () {
      this.loadingMail = false
      if (this.subscribe.subscribed) {
        this.$store.commit('SET_DISPLAY_NOTIFICATION', {show: true,
        msg:this.$lang.messages.sub_succ, state: true})
      } else {
        this.invalidMail = true
        this.$store.commit('SET_DISPLAY_NOTIFICATION', {show: true,
        msg:this.$lang.messages.err2, state: false})
      }
    },
    showMap: function (value) {
      this.largeMap = value
    },
    highlightCloseBtn: function () {
      this.closeBtnHighlighted = true
      var self = this
      setTimeout(function () {
        self.closeBtnHighlighted = false
      }, this.$utilities.getTransitionDurationOfClass('.' + this.cancelTransitionClass) * 1000)
    }
  },
  computed: {
    subscribe () {
      return this.$store.getters.getSubscribe
    }
  },
  watch: {
    'subscribe': 'subscribeUpdated'
  },
  destroyed () {
    this.$store.commit('SET_SUBSCRIBE', null)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/contact.vue